import React from 'react';
import {TextField, Box, IconButton} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

interface EditableCellProps {
    isEditing: boolean;
    value: React.ReactNode;
    editingValue: string;
    onValueChange: (value: string) => void;
    onSave: () => void;
    onCancel: () => void;
    onStartEdit: () => void;
    width?: string | number;
}

export const EditableCell: React.FC<EditableCellProps> = ({
    isEditing,
    value,
    editingValue,
    onValueChange,
    onSave,
    onCancel,
    onStartEdit,
    width = '120px',
}) => {
    return (
        <>
            {isEditing ? (
                <TextField
                    size="small"
                    value={editingValue}
                    onChange={(e) => onValueChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            onSave();
                        } else if (e.key === 'Escape') {
                            onCancel();
                        }
                    }}
                    onBlur={onCancel}
                    autoFocus
                    sx={{width}}
                />
            ) : (
                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <span>{value}</span>
                    <IconButton size="small" color="primary" onClick={onStartEdit}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Box>
            )}
        </>
    );
};
